// extracted by mini-css-extract-plugin
module.exports = {"iconColumnWrapper":"internalColumn_iconColumnWrapper__7TuJB","tooltip":"internalColumn_tooltip__1wGD3","documents":"internalColumn_documents__1I9N_"};